import React from "react";
import {Form, Input, Select, Spin} from "antd";
import {DisposalWasteStreamList} from "../../models/crm/disposal";

const Option = Select.Option;
const FormItem = Form.Item;
const {TextArea} = Input;

class WasteStreamFilterForm extends React.Component {
    state = {
        visible: false,
        data: [],
        value: [],
        fetching: false
    };

    onClose = () => {
        this.setState({
            visible: false
        });
    };
    fetchWasterStreamCode = (value = '') => {
        this.setState({fetching: true});
        const requestData = {'search': value};
        DisposalWasteStreamList(requestData)
            .then(response => {
                this.setState({data: response.data.results, fetching: false});
            });
    };
    handleChange = value => {
        this.setState({
            value,
            fetching: false
        });
        value && this.props.onChange(value.key);
    };
    resetValue = () => {
        this.props.form.resetFields();
        this.setState({
            value: {key: '', label: ''},
            fetching: false
        });
    };


    componentDidMount() {
        if (this.props.onRef)
            this.props.onRef(this)

    }

    componentWillUnmount() {
        if (this.props.onRef)
            this.props.onRef(null)
    }

    render() {
        const {fetching, data, value, fields} = this.state;
        const {getFieldDecorator} = this.props.form;
        return (
            <div className="pos-relative">
                <Select labelInValue showSearch value={value} placeholder="Select Waste Stream Code"
                        dropdownClassName="drawer-select"
                        notFoundContent={fetching ? <Spin size="small"/> : "Not Found"} filterOption={false}
                        onFocus={this.fetchWasterStreamCode} onSearch={this.fetchWasterStreamCode}
                        onChange={this.handleChange} style={{width: "100%"}}>
                    {data.map(d => (<Option key={d.id}>{`${d.code} ${d.description} ${d.unit}`}</Option>))}
                </Select>
            </div>
        );
    }
}

export const DisposalWasteFilter = Form.create()(WasteStreamFilterForm);


// WEBPACK FOOTER //
// ./src/filters/crm/WasteStreamCode.jsx